import { AbstractControl } from "@angular/forms";
import { Estacionamento } from "app/pages/full-pages/estacionamento/estacionamento.model";
import { TipoVaga } from "app/pages/full-pages/vaga/tipoVaga.model";
import { Observable } from "rxjs";

export abstract class AbStepVagas {
  abstract resultadoLazy: boolean;
  abstract numeroVagasLazy: boolean;
  abstract tipoVaga: TipoVaga;
  abstract numeroVagas: number;
  abstract iniciandoNumeroVagas: number;
  abstract estacionamento: Estacionamento;
  abstract numeroVagasCompleted: boolean;
  abstract resultadoCompleted: boolean;
  protected abstract valorAcimaDeZero(AC: AbstractControl);
  abstract getNumeroVagasCompleted(): boolean;
  abstract getResultadoCompleted(): boolean;
  abstract setNumeroVagasCompleted(completed: boolean): Observable<any>;
  abstract setResultadoCompleted(completed: boolean): Observable<any>;
  abstract observableCompleted(): Observable<boolean>;
}